import axios from "axios";
import { sortBy } from "lodash";
import { useEffect, useState } from "react";

interface LeasingObject {
  value: string;
  name: string;
  display_text: string; // deprecated
}

export const useLeasingObjectsList = (language: string) => {
  const [objects, setObjects] = useState<LeasingObject[]>([
    { name: "", value: "", display_text: "" },
  ]);

  useEffect(() => {
    axios
      .get<LeasingObject[]>(`api/v1/leasing-product-types`, {
        params: { language },
      })
      .then((res) => setObjects(sortBy(res.data, (r) => r.name)));
  }, [language]);

  return objects;
};
